import { useTranslator } from '@bluebeam/react-i18n';
import { LinkTab, LinkTabs } from 'components/LinkTabs';
import Navigation from 'components/Navigation';
import { Route } from 'components/Routes/Route';
import React, { FC } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import PublishedTab from './PublishedTab';
import UploadsTab from './UploadsTab';

interface Props {
  match: {
    isExact: boolean;
    params: Object;
    path: string;
    url: string;
  };
}

const DrawingsPage: FC<Props> = ({ match }) => {
  const { translate } = useTranslator(['drawingsPage']);
  return (
    <Navigation>
      <div className="flex flex-col grow">
        <div className="mx4 mt3">
          <LinkTabs>
            <LinkTab
              name={translate('drawingsPage:published')}
              path={`${match.url}/published`}
            />
            <LinkTab
              name={translate('drawingsPage:uploads')}
              path={`${match.url}/uploads`}
            />
          </LinkTabs>
        </div>
        <Switch>
          <Route path={`${match.url}/uploads`} component={UploadsTab} />
          <Route path={`${match.url}/published`} component={PublishedTab} />
          <Route
            path={match.url}
            render={(): React.ReactNode => (
              <Redirect to={`${match.url}/published`} />
            )}
          />
        </Switch>
      </div>
    </Navigation>
  );
};

export default DrawingsPage;
